import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'qmg-single-select-wrapper',
    templateUrl: './single-select-wrapper.component.html',
    styleUrls: ['./single-select-wrapper.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'single-select-wrapper',
    },
    standalone: false
})
export class LcsSingleSelectWrapperComponent {}
